module.exports = __webpack_public_path__ + "static/easy_to_maintain_HR-e1e401427bf846404f119245f077fd33.mp4";